// extracted by css-extract-rspack-plugin
export default {"clearButton":"ClearButton-module__clearButton__wvAWiEp"};